import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["overrides", "className", "labelMode", "isFullWidth", "isReadOnly", "schema", "onSubmit", "onChange", "onFocus", "onBlur", "values", "errors", "customFields", "useNativeForm", "orientation"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { getOverrides } from '../../../../utils/overrides';
import MultiplierFieldControl from '../MultiplierFieldControl';
import Section from '../../Section';
function MultiplierForm(_ref) {
  var overridesProp = _ref.overrides,
    classNameProp = _ref.className,
    labelMode = _ref.labelMode,
    isFullWidth = _ref.isFullWidth,
    isReadOnly = _ref.isReadOnly,
    schema = _ref.schema,
    onSubmit = _ref.onSubmit,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    values = _ref.values,
    errors = _ref.errors,
    customFields = _ref.customFields,
    useNativeForm = _ref.useNativeForm,
    orientation = _ref.orientation,
    props = _objectWithoutProperties(_ref, _excluded);
  // Overrides
  var override = getOverrides(overridesProp, MultiplierForm.overrides);
  var onChangeField = useCallback(function (value, field) {
    var newValues = _objectSpread(_objectSpread({}, values), {}, _defineProperty({}, field.name, value));
    if (field.type === 'inputGroup') {
      newValues = _objectSpread(_objectSpread({}, values), value);
    }
    onChange && onChange(newValues, field, value);
  }, [values, onChange]);
  var onFocusField = useCallback(function (value, field) {
    onFocus && onFocus(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, field.name, value)), field, value);
  }, [onFocus, values]);
  var onBlurField = useCallback(function (value, field) {
    onBlur && onBlur(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, field.name, value)), field, value);
  }, [onBlur, values]);
  var onEnterField = useCallback(function (value, field) {
    onSubmit && onSubmit(_objectSpread(_objectSpread({}, values), {}, _defineProperty({}, field.name, value)), field, value);
  }, [onSubmit, values]);
  var content = schema.map(function (section, index) {
    return /*#__PURE__*/React.createElement(Section, _extends({
      key: index,
      title: section.title,
      className: section.className,
      isExpandable: section.isExpandable,
      orientation: orientation
    }, override.Section), section.fields.map(function (field) {
      var value = values && values[field.name] ? values[field.name] : undefined;
      if (field.type === 'inputGroup') {
        value = values;
      }
      return /*#__PURE__*/React.createElement(MultiplierFieldControl, {
        key: field.name,
        labelMode: field.labelMode || labelMode,
        isFullWidth: field.isFullWidth || isFullWidth,
        isReadOnly: isReadOnly || field.isReadOnly,
        field: field,
        value: value,
        error: errors[field.name],
        onEnter: onEnterField,
        onChange: onChangeField,
        onFocus: onFocusField,
        onBlur: onBlurField,
        className: field.className,
        customFields: customFields,
        overrides: overridesProp
      });
    }));
  });
  var withForm = function withForm(children) {
    return /*#__PURE__*/React.createElement("form", _extends({
      className: classNameProp,
      action: "",
      autoComplete: "off"
    }, override.root), children);
  };
  var withDiv = function withDiv(children) {
    return /*#__PURE__*/React.createElement("div", _extends({
      className: classNameProp
    }, override.root), children);
  };
  if (useNativeForm) return withForm(content);
  return withDiv(content);
}
MultiplierForm.overrides = ['root', 'Section'];
MultiplierForm.defaultProps = {
  labelMode: 'horizontal',
  isFullWidth: false,
  errors: {},
  values: {},
  schema: [],
  override: {},
  useNativeForm: false
};
process.env.NODE_ENV !== "production" ? MultiplierForm.propTypes = {
  /** Native form class */
  className: PropTypes.string,
  labelMode: PropTypes.string,
  isFullWidth: PropTypes.bool,
  isReadOnly: PropTypes.bool,
  values: PropTypes.object,
  errors: PropTypes.object,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onSubmit: PropTypes.func,
  customFields: PropTypes.object,
  useNativeForm: PropTypes.bool,
  schema: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    className: PropTypes.string,
    isExpandable: PropTypes.bool,
    fields: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      labelMode: PropTypes.string,
      isFullWidth: PropTypes.bool,
      name: PropTypes.string,
      type: PropTypes.string,
      placeholder: PropTypes.string,
      hint: PropTypes.string,
      isRequired: PropTypes.bool,
      isReadOnly: PropTypes.bool,
      attrs: PropTypes.object,
      className: PropTypes.string
    }))
  })).isRequired,
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
} : void 0;
export default /*#__PURE__*/React.memo(MultiplierForm);